var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: {
            title: "默认值设置",
            visible: _vm.dialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { overflow: "scroll" },
              attrs: { inline: "", "label-position": "top" },
            },
            [
              _c(
                "el-form-item",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.copyCurrentItem.config.label
                                ),
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3224357213
                  ),
                },
                [
                  _c(
                    _vm.copyCurrentItem.config.tag,
                    _vm._b(
                      {
                        tag: "component",
                        staticClass: "form-item-component",
                        attrs: { item: _vm.copyCurrentItem },
                        model: {
                          value: _vm.copyCurrentItem.config.defaultValue,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.copyCurrentItem.config,
                              "defaultValue",
                              $$v
                            )
                          },
                          expression: "copyCurrentItem.config.defaultValue",
                        },
                      },
                      "component",
                      Object.assign({}, _vm.copyCurrentItem),
                      false
                    )
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.setDefaultValue },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }